module.exports = __webpack_public_path__ + "static/media/makeorder.d2603e20.svg";